import { type ReactNode } from 'react';

import { Badge, type BadgeVariant } from '@hungryroot/pho';
import { type PdpHeroAvailabilityBadgeVariant } from '../../types/pdpHeroAvailabilityBadge';
import styles from './HeroImageArea.module.css';

type Props = {
  badge: PdpHeroAvailabilityBadgeVariant | null | undefined;
  children: ReactNode;
};

const copy: Record<PdpHeroAvailabilityBadgeVariant, string> = {
  coming_soon: 'Coming Soon',
  out_of_stock: 'Out of Stock',
};

const badgeVariant: Record<PdpHeroAvailabilityBadgeVariant, BadgeVariant> = {
  coming_soon: 'ComingSoon',
  out_of_stock: 'OutOfStock',
};

/** Shared wrapper for the hero image stack + optional PDP availability badge. */
export function HeroImageArea({ badge, children }: Props): ReactNode {
  if (!badge || children == null) {
    return children;
  }

  return (
    <div className={styles['image-area']}>
      {children}
      <div
        className={styles['image-hero-badge']}
        data-testid="pdp-hero-availability-badge"
      >
        <Badge variant={badgeVariant[badge]} label={copy[badge]} />
      </div>
    </div>
  );
}
